import { useEffect, useState } from "react";
import AppButton from "../elements/AppButton";
import useApiRequest from "../../helpers/api_request";
import { AxiosError } from "axios";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { BASE_URL } from "../../helpers/constants";
import { selectAccessToken } from "../../features/auth/authSlice";
import { showToastMessage } from "../../features/generalSlice";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import useDataSources from "../../hooks/useDataSources";
import AppSpinner from "../elements/AppSpinner";

const CreateDataSourcePage = () => {
    const [isSavingDataSource, setIsSavingDataSource] = useState(false)
    const accessToken = useAppSelector(selectAccessToken);
    const [name, setName] = useState("");
    const [website, setWebsite] = useState<string|undefined>("");
    const [dataSourceId, setDataSourceId] = useState<number | null>(null);

    const apiRequest = useApiRequest()
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const { id } = useParams();
    const {
        loadingDataSources,
        dataSources,
        getDataSources,
    } = useDataSources();

    useEffect(() => {
        if (id != null) {
            getDataSources();
        }
    }, []);

    useEffect(() => {
        if (id != null) {
            const dataSource = dataSources.filter((item) => item.id == parseInt(id))
            if (dataSource.length > 0) {
                setName(dataSource[0].name)
                setWebsite(dataSource[0].website)
                setDataSourceId(dataSource[0].id)
            }
        }
    }, [dataSources])

    const saveDataSource = async () => {
        if (name === "") {
            dispatch(showToastMessage({
                message: "Name is required",
                type: "error",
                position: toast.POSITION.TOP_RIGHT
            }));
            return
        }
        setIsSavingDataSource(true)
        await apiRequest({
            method: 'post',
            url: BASE_URL + "/api/data-source/create",
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
            data: {
                name: name,
                website:website,
                data_source_id: dataSourceId
            }
        }).then((response) => {
            setIsSavingDataSource(false)
            dispatch(showToastMessage({
                message: "Data source Saved saved",
                type: "success",
                position: toast.POSITION.TOP_RIGHT
            }));
            navigate("/data-sources")
        }).catch((error) => {
            const errorResponse = error as AxiosError;
            if (errorResponse.response) {
                const data = errorResponse.response.data as { message: string, status: string };
                dispatch(showToastMessage({
                    message: data.message,
                    type: "error",
                    position: toast.POSITION.TOP_RIGHT
                }));
            } else {
                dispatch(showToastMessage({
                    message: "Something went wrong",
                    type: "error",
                    position: toast.POSITION.TOP_RIGHT
                }));
            }
            setIsSavingDataSource(false)
        });
    }
    return (
        <div>
            <div className="card">
                <div className=" card-body min-h-half-screen">

                    <div className="flex">
                        <nav className="flex justify-between " aria-label="Breadcrumb">
                            <ol className="inline-flex items-center mb-3 sm:mb-0">
                                <li>
                                    <div className="flex items-center">
                                        <h5 className=" card-title ">Data Sources</h5>
                                    </div>
                                </li>
                                <span className="mx-2 text-gray-400">/</span>
                                <li aria-current="page">
                                    <div className="flex items-center">
                                        <h5 className=" card-title ">
                                            {id == null ? "Create" : "Edit"}
                                        </h5>
                                    </div>
                                </li>
                            </ol>
                        </nav>
                    </div>
                    {
                        (loadingDataSources) ? <AppSpinner /> :
                            <div className=" h-fit flex-grow flex flex-col justify-center ">
                                <div className=" w-2/3 mt-4">
                                    <label className="block text-sm font-medium text-gray-700 "> Name of MDA</label>
                                    <input value={name} onChange={(e) => setName(e.target.value)} type="text" id="name" className="form-input-2" placeholder="" />
                                </div>

                                <div className=" w-2/3 mt-4">
                                    <label className="block text-sm font-medium text-gray-700 "> Website</label>
                                    <input value={website} onChange={(e) => setWebsite(e.target.value)} type="text" id="name" className="form-input-2" placeholder="" />
                                </div>

                                <div className="w-2/3 mt-4">
                                    <AppButton callBackFun={() => saveDataSource()} showLoader={isSavingDataSource} spinnerClass="inline w-3 h-3 mr-2 text-prim-yellow animate-spin fill-black" className="prim-btn-2" text="Save" />
                                </div>
                            </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default CreateDataSourcePage;